import { useContext } from 'react';

import { XYChartToolbarContext } from '../context/XYChartToolbar.context.js';

export const useToolbar = () => {
  const context = useContext(XYChartToolbarContext);

  if (context === undefined) {
    throw new Error('useToolbar must be used within a XYChartToolbarContext');
  }

  return context;
};
